module.exports = __webpack_public_path__ + "img/beranda.bb40b0e.png";